import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.regexp.replace.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import axios from 'axios';
import cloneDeep from 'lodash/cloneDeep';
import camelCase from 'lodash/camelCase';
import Logger from 'js-logger';
import qs from 'qs';
import Vuex from 'vuex';
import { camelise, hash, snakify } from '@/functions/utils';
import { i18n } from '@/boot/i18n';
import { throwErrors } from '@/boot/sentry';
import { store } from '@/store';
import { version } from "../../package.json"; // Display an error accompanying an API call, with help from configured errorBehaviour.

function displayError(error, errorBehaviour) {
  var _errorBehaviour$displ;

  // Display errors if enabled, it is enabled by default.
  if ((_errorBehaviour$displ = errorBehaviour.display) !== null && _errorBehaviour$displ !== void 0 ? _errorBehaviour$displ : true) {
    var _error$previous, _error$previous$log;

    // Look to the formatter to determine the format of the error displayed
    var messageFormatter = errorBehaviour.messageFormatter || function (error) {
      return error.message;
    };

    store.dispatch('errors/display', {
      error: messageFormatter(error),
      // We provide the log reference and error code in the trace, which is succinct
      trace: {
        type: 'API',
        value: (_error$previous = error.previous) === null || _error$previous === void 0 ? void 0 : (_error$previous$log = _error$previous.log) === null || _error$previous$log === void 0 ? void 0 : _error$previous$log.ref
      }
    });
  }
}

function redirectBasedOnError(error) {
  var router = store.$router; // The API consistently returns a 401 Unauthorized if a non-authenticated action has been performed.

  if (error.status === 401 && store.get('config/isApp')) {
    // If we're on the app version of the survey, this will be due to a non-authenticated staff member
    // accessing part of the site they shouldn't be - so force them back to the Register page (unless
    // they're on the Register page - in which case we want any relevant authentication errors to be
    // presented).
    //   We need to do the same thing here as we do if the staff member were to manually de-authenticate
    // the device. This will remove any local data due to the device not being authenticated - which
    // is great for security purposes.
    //   Most relevantly we need to do this so that the redirect below won't redirect past the
    // Register page (due to it thinking the staff member has already registered by checking the store state).
    if (router.currentRoute.path !== '/register') {
      // Only reset persistent data if we're not on the Register page. If we did do it on the
      // Register page then people logging in wouldn't see the modal containing the error indicating
      // a failed log in attempt.
      store.dispatch('settings/resetAllModuleStates');
      Logger.debug("Redirecting from '".concat(router.currentRoute.path, "' as the device isn't authenticated"));
      router.push('/register');
    }
  }
} // Handle an error accompanying an API call.


function handleApiError(e, errorBehaviour) {
  var _e$response, _e$response$data, _e$response2, _e$response2$data, _e$response3;

  // Log now, before something (potentially) goes wrong
  if (e.response) {
    Logger.error('Error Response:', e.response);
  } // Extract error details (returned by the API) from the exception


  var apiError = e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : _e$response$data.error;
  var defaultMessage = i18n.t('error.api.response');

  var error = _objectSpread({
    status: ((_e$response2 = e.response) === null || _e$response2 === void 0 ? void 0 : (_e$response2$data = _e$response2.data) === null || _e$response2$data === void 0 ? void 0 : _e$response2$data.status) || ((_e$response3 = e.response) === null || _e$response3 === void 0 ? void 0 : _e$response3.status),
    // API or HTTP status code
    // Set a generic error message (as the fallback) if we didn't get a usable error message in the exception
    message: defaultMessage
  }, apiError ? {
    type: 'api',
    code: apiError.code,
    detail: apiError.detail,
    // If the ui field is set, render the message as passed - else use the fallback.
    message: apiError.ui ? apiError.message : defaultMessage,
    previous: apiError
  } : {
    // Use the error message returned by the browser (e.g. network error)
    type: 'unknown',
    message: e.message,
    previous: e
  }); // Log the parsed error


  throwErrors(error);
  displayError(error, errorBehaviour);
  redirectBasedOnError(error); // Return the parsed error

  return error;
} // Fixed API clientside metadata


var authType = function authType() {
  return store.get('config/isApp') ? 'app' : 'web';
}; // For the client, we only bother sending the first 7 chars in the commit hash -
// it's more than good enough and saves space!


var client = function client() {
  return "fib.".concat(authType(), "-").concat(version, "#") + (process.env.COMMIT_HASH || '').toString().slice(0, 7);
}; // Call an API endpoint using the specified method with any supplied parameters/headers and
// return either the response or an error object


function api(_x) {
  return _api.apply(this, arguments);
} // Map dynamic header names from internal to the X-FIB-API version.


function _api() {
  _api = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(_ref) {
    var endpoint, method, _ref$payload, payload, _ref$headers, headers, _ref$errorBehaviour, errorBehaviour, contentType, params, bodyText, data, snaked, _snaked, getHeaders, options, response;

    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            getHeaders = function _getHeaders() {
              // Declare values for populating the headers
              var branch = store.get('config/branchId') || '';
              var company = store.get('config/companyKey') || '';
              var device = store.get('config/deviceId') || '';
              var language = store.get('settings/language');
              var passcode = store.get('config/passcode') || '';
              var uuid = store.get('config/uuid') || ''; // Build a hash for X-FIB-API-AUTH-PASS

              var authPass = hash(bodyText + device.toUpperCase() + passcode + uuid); // Logger.debug('authPassBuild: ', {  bodyText, device, passcode, uuid, authPass })
              // Common headers applicable to both app and web

              var commonHeaders = {
                'Content-Type': contentType,
                'X-FIB-API-AUTH-TYPE': authType(),
                'X-FIB-API-BRANCH': branch,
                'X-FIB-API-CLIENT': client(),
                'X-FIB-API-COMPANY': company,
                'X-FIB-API-LANGUAGE': language
              }; // App specific headers

              var appHeaders = {
                'X-FIB-API-AUTH-PASS': authPass,
                'X-FIB-API-DEVICE': device ? device.toUpperCase() : ''
              };
              var webHeaders = {
                'X-FIB-API-AUTH-TOKEN': process.env.API_AUTH_TOKEN
              }; // Return the appropriate headers for app or web

              return store.get('config/isApp') ? _objectSpread(_objectSpread(_objectSpread({}, commonHeaders), appHeaders), headers) : _objectSpread(_objectSpread(_objectSpread({}, commonHeaders), webHeaders), headers);
            };

            endpoint = _ref.endpoint, method = _ref.method, _ref$payload = _ref.payload, payload = _ref$payload === void 0 ? null : _ref$payload, _ref$headers = _ref.headers, headers = _ref$headers === void 0 ? {} : _ref$headers, _ref$errorBehaviour = _ref.errorBehaviour, errorBehaviour = _ref$errorBehaviour === void 0 ? {} : _ref$errorBehaviour;
            method = method.toLowerCase(); // Force to lower case to ensure we match correctly

            contentType = payload && payload.json ? 'multipart/form-data' : 'application/json';
            params = method === 'get' ? snakify(payload) || {} : {};

            if (process.env.API_DEBUGGING) {
              params.XDEBUG_SESSION_START = 'xdebug-fib';
            }

            bodyText = '';
            data = null;

            if (payload && method === 'post') {
              if (payload.json) {
                snaked = snakify(payload.json); // Recursively rename all properties to snake case

                data = new FormData();
                bodyText = JSON.stringify(snaked);
                data.set('json', bodyText);
                data.append('image', payload.image);
              } else {
                _snaked = snakify(payload);
                data = bodyText = JSON.stringify(_snaked);
              }
            }

            _context21.prev = 9;
            // Define the Axios options
            options = {
              baseURL: process.env.API_URL,
              data: data,
              headers: getHeaders(),
              method: method,
              params: params,
              paramsSerializer: function paramsSerializer(params) {
                return qs.stringify(params);
              },
              timeout: process.env.API_TIMEOUT,
              url: endpoint,
              withCredentials: true // This is required for the API to have access to cookies for tracking fraud

            }; // Call the API

            Logger.debug("API Request: ".concat(method.toUpperCase(), " ").concat(endpoint, "?").concat(qs.stringify(params)));
            store.set('settings/apiInProgress', true);
            _context21.next = 15;
            return axios(options);

          case 15:
            response = _context21.sent;
            store.set('settings/apiInProgress', false);
            Logger.debug('API Response:', response); // Throw an exception if the response status code isn't in the 2xx range

            if (response.status >= 200 && response.status <= 299) {
              _context21.next = 20;
              break;
            }

            throw new Error();

          case 20:
            // recursively rename all incoming data properties to camelCase
            response.data = camelise(response.data);
            return _context21.abrupt("return", response);

          case 24:
            _context21.prev = 24;
            _context21.t0 = _context21["catch"](9);
            return _context21.abrupt("return", {
              error: handleApiError(_context21.t0, errorBehaviour)
            });

          case 27:
            _context21.prev = 27;
            store.set('settings/apiInProgress', false);
            return _context21.finish(27);

          case 30:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21, null, [[9, 24, 27, 30]]);
  }));
  return _api.apply(this, arguments);
}

function renameHeaders(headers) {
  var renames = {
    responseId: 'X-FIB-API-RESPONSE',
    responseSecret: 'X-FIB-API-RESPONSE-SECRET',
    templateId: 'X-FIB-API-TEMPLATE'
  };
  Object.keys(renames).forEach(function (key) {
    if (!headers.hasOwnProperty(key)) {
      return;
    }

    headers[renames[key]] = headers[key];
    delete headers[key];
  });
  return headers;
} // Throw away any enveloping on a response if possible


var unenvelope = function unenvelope(response, root) {
  var _response$data;

  return response !== null && response !== void 0 && response.error ? response : response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data[camelCase(root)];
};

var apiEndpoints = {
  //////////////////////////////////////////////////////////////////////////////////////////////////
  //   _______           __     ____
  //  / ___/ /  ___ ____/ /__  /  _/__
  // / /__/ _ \/ -_) __/  '_/ _/ // _ \
  // \___/_//_/\__/\__/_/\_\ /___/_//_/
  //

  /**
   * Fetch company branches by location.
   *
   * @param {Object} location location parameters
   *
   * @returns {Object} Branches data object on success or an error object on failure
   */
  fetchBranches: function fetchBranches() {
    var _arguments = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var location, headers;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              location = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : null;
              headers = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {};
              _context.next = 4;
              return api({
                endpoint: 'survey.branch',
                method: 'get',
                payload: location,
                headers: headers
              });

            case 4:
              return _context.abrupt("return", _context.sent);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },

  /**
   * Fetch transaction data.
   *
   * @param {Object} params transaction parameters
   * @param {Object} params.branchId branch ID (optional)
   * @param {Object} params.templateId template ID
   * @param {Object} params.transactionRef transaction reference
   *
   * @returns {Object} Team member data object on success or an error object on failure
   */
  fetchTransactionData: function fetchTransactionData(params) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (params && params.templateId) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return", false);

            case 2:
              _context2.next = 4;
              return api({
                endpoint: 'survey.transaction',
                method: 'get',
                payload: params,
                headers: renameHeaders({
                  templateId: params.templateId
                })
              });

            case 4:
              return _context2.abrupt("return", _context2.sent);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  //////////////////////////////////////////////////////////////////////////////////////////////////
  //   _____          ____
  //  / ___/__  ___  / _(_)__ ____
  // / /__/ _ \/ _ \/ _/ / _ `(_-<
  // \___/\___/_//_/_//_/\_, /___/
  //                    /___/

  /**
   * Fetch the configuration data.
   *
   * @param {Array} edge List of config edges to fetch, default is all items
   *
   * @returns {Object}
   */
  fetchConfig: function fetchConfig() {
    var _arguments2 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var edge, headers, showError, payload, errorBehaviour;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              edge = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : [];
              headers = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : {};
              showError = _arguments2.length > 2 ? _arguments2[2] : undefined;
              edge = (edge || []).join(',');
              payload = edge ? {
                edge: edge
              } : {};

              if (!showError) {
                errorBehaviour = {
                  // Mute this as no-one cares if this fails apart from someone looking at the network tab
                  display: false
                };
              }

              _context3.next = 8;
              return api({
                endpoint: 'survey.config',
                method: 'get',
                payload: payload,
                headers: headers,
                errorBehaviour: errorBehaviour
              });

            case 8:
              return _context3.abrupt("return", _context3.sent);

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },

  /**
   * Fetch the question and survey data.
   *
   * @param {String} edge Comma separated list of items to fetch, default is questions and surveys
   *
   * @returns {Object}
   */
  fetchSurveys: function fetchSurveys() {
    var _arguments3 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var edge, payload;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              edge = _arguments3.length > 0 && _arguments3[0] !== undefined ? _arguments3[0] : 'questions,surveys';
              edge = edge.replace(/\s/g, ''); // Remove all whitespace

              payload = edge ? {
                edge: edge
              } : {};
              _context4.next = 5;
              return api({
                endpoint: 'survey.config',
                method: 'get',
                payload: payload
              });

            case 5:
              return _context4.abrupt("return", _context4.sent);

            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },
  //////////////////////////////////////////////////////////////////////////////////////////////////
  //    ___           _     __           __  _
  //   / _ \___ ___ _(_)__ / /________ _/ /_(_)__  ___
  //  / , _/ -_) _ `/ (_-</ __/ __/ _ `/ __/ / _ \/ _ \
  // /_/|_|\__/\_, /_/___/\__/_/  \_,_/\__/_/\___/_//_/
  //          /___/

  /**
   * Change settings passcode.
   *
   * @param {Object} payload Passcode payload
   * @param {String} payload.pass Auth Pass
   * @param {Object} payload.settingsPasscode Settings passcode
   * @param {String} payload.uuid Unique device id
   *
   * @returns {Object}
   */
  changeSettingsPasscode: function changeSettingsPasscode(payload) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return api({
                endpoint: 'device.configure',
                method: 'post',
                payload: payload
              });

            case 2:
              return _context5.abrupt("return", _context5.sent);

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },

  /**
   * Deregister a device.
   *
   * @param {Object} payload Deregistration payload
   * @param {String} payload.pass Auth Pass
   * @param {String} payload.uuid Unique device id
   *
   * @returns {Object}
   */
  deregisterDevice: function deregisterDevice(payload) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return api({
                endpoint: 'device.deregister',
                method: 'post',
                payload: payload
              });

            case 2:
              return _context6.abrupt("return", _context6.sent);

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  },

  /**
   * Register a device.
   *
   * @param {Object} payload Registration payload
   * @param {String} payload.pass Auth Pass
   * @param {String} payload.settingsPasscode Settings passcode
   * @param {String} payload.uuid Unique device id
   *
   * @returns {Object}
   */
  registerDevice: function registerDevice(payload) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return api({
                endpoint: 'device.register',
                method: 'post',
                payload: payload
              });

            case 2:
              return _context7.abrupt("return", _context7.sent);

            case 3:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }))();
  },
  //////////////////////////////////////////////////////////////////////////////////////////////////
  //    ___
  //   / _ \___ ___ ___  ___  ___  ___ ___ ___
  //  / , _/ -_|_-</ _ \/ _ \/ _ \(_-</ -_|_-<
  // /_/|_|\__/___/ .__/\___/_//_/___/\__/___/
  //             /_/

  /**
   * Submit a survey response.
   *
   * @param {Object} payload Submit payload
   * @param {Number} headers.templateId The template id
   *
   * @returns {Object} {id, url} on success (the survey response id and shareable public url to the scorecard) or an error object on failure
   */
  submit: function submit(_ref2) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      var payload, headers;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              payload = _ref2.payload, headers = _ref2.headers;
              _context8.next = 3;
              return api({
                endpoint: 'survey.submit',
                method: 'post',
                payload: payload,
                headers: renameHeaders(headers)
              });

            case 3:
              return _context8.abrupt("return", _context8.sent);

            case 4:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }))();
  },

  /**
   * Upload an image file in association with a survey response.
   *
   * @param {File} payload.image The image file to be uploaded in association with the survey response
   * @param {Number} headers.responseId The survey response id
   * @param {String} headers.responseSecret The survey response secret
   *
   * @returns {Object}
   */
  upload: function upload(_ref3) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      var image, headers, errorBehaviour;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              image = _ref3.payload.image, headers = _ref3.headers, errorBehaviour = _ref3.errorBehaviour;
              _context9.next = 3;
              return api({
                endpoint: 'survey.upload.upsert',
                method: 'post',
                payload: {
                  json: {},
                  image: image
                },
                headers: renameHeaders(headers),
                errorBehaviour: errorBehaviour
              });

            case 3:
              return _context9.abrupt("return", _context9.sent);

            case 4:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }))();
  },

  /**
   * Delete a file upload stored against a survey response
   *
   * @param {Number} headers.responseId The survey response id
   * @param {String} headers.responseSecret The survey response secret
   *
   * @returns {Object}
   */
  deleteUpload: function deleteUpload(_ref4) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
      var headers;
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              headers = _ref4.headers;
              _context10.next = 3;
              return api({
                endpoint: 'survey.upload.delete',
                method: 'post',
                payload: {},
                headers: renameHeaders(headers),
                errorBehaviour: {
                  // Mute this as no-one cares if this fails apart from someone looking at the network tab
                  display: false
                }
              });

            case 3:
              return _context10.abrupt("return", _context10.sent);

            case 4:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }))();
  },

  /**
   * Track actions carried out with a survey response.
   *
   * @param {Object} payload Track payload
   * @param {Number} headers.responseId The survey response id
   *
   * @returns {Object}
   */
  track: function track(_ref5) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
      var payload, headers;
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              payload = _ref5.payload, headers = _ref5.headers;
              _context11.next = 3;
              return api({
                endpoint: 'survey.track',
                method: 'post',
                payload: payload,
                headers: renameHeaders(headers)
              });

            case 3:
              return _context11.abrupt("return", _context11.sent);

            case 4:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }))();
  },
  fetchRecommendSuggestion: function fetchRecommendSuggestion(_ref6) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
      var headers;
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              headers = _ref6.headers;
              _context12.next = 3;
              return api({
                endpoint: 'survey.prompt',
                method: 'get',
                headers: renameHeaders(headers),
                errorBehaviour: {
                  // Mute this as errors are handled by the UI element that calls this
                  display: false
                }
              });

            case 3:
              return _context12.abrupt("return", _context12.sent);

            case 4:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }))();
  },
  //////////////////////////////////////////////////////////////////////////////////////////////////
  //    __  ___                ___       __
  //   /  |/  /__ ___  __ __  / _ \___ _/ /____ _
  //  / /|_/ / -_) _ \/ // / / // / _ `/ __/ _ `/
  // /_/  /_/\__/_//_/\_,_/ /____/\_,_/\__/\_,_/

  /**
   * Query menu data - only available for the web build.
   *
   * @param {Object} payload Menu query payload
   * @param {String} payload.edge The epos type to query - one of (products, family_groups, major_groups)
   * @param {Number} payload.page The 1-based page into the data for the provided edge
   * @param {Number} payload.size The page size, you are advised to use the default, and not set this at all (so that the backend may define the pagination)
   * @param {String} payload.text A text filter to be applied to the edge
   * @param {String} payload.textFields If a text filter is provided, the fields to apply the text filter to on the edge.
   * @param {Array} payload.order The order of the data for the edge
   * @param {String} payload.type An internal product type id to filter by
   * @param {String} payload.familyGroupRef A family group epos id to filter by
   * @param {String} payload.majorGroupRef A major group epos id to filter by
   * @param {Array} payload.transactionProductRefs In the case of a transaction having been retrieved, an Array of non-modifier, non-free product epos ids as strings retrieved
   *
   * @returns {Object}
   */
  queryMenuData: function queryMenuData(payload) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              // Map array fields only when they've been provided
              ['transactionProductRefs', 'order', 'textFields'].forEach(function (field) {
                if (field in payload) {
                  payload[field] = (payload[field] || []).join(',');
                }
              });
              _context13.t0 = unenvelope;
              _context13.next = 4;
              return api({
                endpoint: 'survey.menu.query',
                method: 'get',
                payload: payload
              });

            case 4:
              _context13.t1 = _context13.sent;
              _context13.t2 = payload.edge;
              return _context13.abrupt("return", (0, _context13.t0)(_context13.t1, _context13.t2));

            case 7:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }))();
  },

  /**
   * Export menu data - only available for the app build.
   *
   * @param {Object} payload Menu export payload
   * @param {String} payload.edge The epos type to query - one of (products, family_groups, major_groups)
   * @param {Number} payload.page The 1-indexed page into the data for the provided edge
   * @param {Number} payload.size The page size, you are advised to use the default, and not set this at all (so that the backend may define the pagination)
   * @param {Number} payload.since Only return data updated since this unix timestamp. Obtain this by taking the max of your consumed data
   * @param {Boolean} payload.just_ids Only return ids - required to determine what ids in your consumed data should be deleted as it no longer exists centrally
   *
   * @returns {Object}
   */
  exportMenuData: function exportMenuData(payload) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.t0 = unenvelope;
              _context14.next = 3;
              return api({
                endpoint: 'survey.menu.export',
                method: 'get',
                payload: payload,
                errorBehaviour: {
                  display: false
                }
              });

            case 3:
              _context14.t1 = _context14.sent;
              _context14.t2 = payload.edge;
              return _context14.abrupt("return", (0, _context14.t0)(_context14.t1, _context14.t2));

            case 6:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    }))();
  },
  //////////////////////////////////////////////////////////////////////////////////////////////////
  //    __  ___                          ______
  //   /  |/  /__ ____  ___ ____ ____   /_  __/__ ___ ___ _
  //  / /|_/ / _ `/ _ \/ _ `/ _ `/ -_)   / / / -_) _ `/  ' \
  // /_/  /_/\_,_/_//_/\_,_/\_, /\__/   /_/  \__/\_,_/_/_/_/
  //                       /___/

  /**
   * Add a team member.
   *
   * @param {Object} payload Payload object
   * @param {Object} payload.displayName Member hasSettingsAccess value
   * @param {Object} payload.fullName Member fullName value
   * @param {Object} payload.id Member ID
   * @param {File} payload.image Member Photo/Image Upload (file)
   * @param {Object} payload.pinCode Member pinCode value
   * @param {Object} payload.status Member status value
   * @param {Object} payload.weight Member weight value
   *
   * @returns {Object} Team member object on success or an error object on failure
   */
  addTeamMember: function addTeamMember(payload) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
      var image, prepped;
      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              // if image, prep for update via multipart/form-data
              image = payload.image;
              delete payload.image;
              prepped = {};

              if (image) {
                prepped = {
                  json: _objectSpread({}, payload),
                  image: image
                };
              } else {
                prepped = _objectSpread({}, payload);
              }

              _context15.next = 6;
              return api({
                endpoint: 'manage.staff.add',
                method: 'post',
                payload: prepped,
                errorBehaviour: {
                  messageFormatter: function messageFormatter(error) {
                    return error.message === 'Network Error' ? i18n.t('manageTeam.teamMemberFailureNoConnection') : i18n.t('manageTeam.addFailure');
                  }
                }
              });

            case 6:
              return _context15.abrupt("return", _context15.sent);

            case 7:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15);
    }))();
  },

  /**
   * Delete team member.
   *
   * @param {Object} member Team member data
   *
   * @returns {Object} response
   */
  deleteTeamMember: function deleteTeamMember(member) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
      var id;
      return _regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              if (member) {
                _context16.next = 2;
                break;
              }

              return _context16.abrupt("return");

            case 2:
              id = member.id; // if id missing, return false

              if (id) {
                _context16.next = 5;
                break;
              }

              return _context16.abrupt("return");

            case 5:
              _context16.next = 7;
              return api({
                endpoint: 'manage.staff.delete/' + id,
                method: 'post',
                errorBehaviour: {
                  messageFormatter: function messageFormatter(error) {
                    return error.message === 'Network Error' ? i18n.t('manageTeam.teamMemberFailureNoConnection') : i18n.t('manageTeam.deleteFailure');
                  }
                }
              });

            case 7:
              return _context16.abrupt("return", _context16.sent);

            case 8:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16);
    }))();
  },

  /**
   * Fetch a single team member's data.
   *
   * @param {Number} id member id
   *
   * @returns {Object} Team member data object on success or an error object on failure
   */
  fetchTeamMember: function fetchTeamMember(id) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
      return _regeneratorRuntime.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              if (id) {
                _context17.next = 2;
                break;
              }

              return _context17.abrupt("return", false);

            case 2:
              _context17.next = 4;
              return api({
                endpoint: 'manage.staff.listing/' + id,
                method: 'get'
              });

            case 4:
              return _context17.abrupt("return", _context17.sent);

            case 5:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17);
    }))();
  },

  /**
   * Fetch all team members' data.
   *
   * @returns {Object} Team data object on success or an error object on failure
   */
  fetchTeamMembers: function fetchTeamMembers() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
      return _regeneratorRuntime.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return api({
                endpoint: 'manage.staff.listing',
                method: 'get'
              });

            case 2:
              return _context18.abrupt("return", _context18.sent);

            case 3:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18);
    }))();
  },

  /**
   * Update team member.
   *
   * @param {Object} payload Payload object
   * @param {Object} payload.displayName Member hasSettingsAccess value
   * @param {Object} payload.fullName Member fullName value
   * @param {Object} payload.id Member ID
   * @param {File} payload.image Member Photo/Image Upload (file)
   * @param {Object} payload.pinCode Member pinCode value
   * @param {Object} payload.status Member status value
   * @param {Object} payload.weight Member weight value
   *
   * @returns {Object} Team member object on success or an error object on failure
   */
  updateTeamMember: function updateTeamMember() {
    var _arguments4 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
      var payload, id, member, image, prepped;
      return _regeneratorRuntime.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              payload = _arguments4.length > 0 && _arguments4[0] !== undefined ? _arguments4[0] : {};
              id = payload.id; // if id missing, return false

              if (id) {
                _context19.next = 4;
                break;
              }

              return _context19.abrupt("return", false);

            case 4:
              // remove id from payload
              member = cloneDeep(payload);
              delete member.id; // if image, prep for update via multipart/form-data

              image = member.image;
              delete member.image;
              prepped = {};

              if (image) {
                prepped = {
                  json: _objectSpread({}, member),
                  image: image
                };
              } else {
                prepped = _objectSpread({}, member);
              }

              _context19.next = 12;
              return api({
                endpoint: 'manage.staff.update/' + id,
                method: 'post',
                payload: prepped,
                errorBehaviour: {
                  messageFormatter: function messageFormatter(error) {
                    return error.message === 'Network Error' ? i18n.t('manageTeam.teamMemberFailureNoConnection') : i18n.t('manageTeam.updateFailure');
                  }
                }
              });

            case 12:
              return _context19.abrupt("return", _context19.sent);

            case 13:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19);
    }))();
  },
  fetchTeamListings: function fetchTeamListings() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
      return _regeneratorRuntime.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return api({
                endpoint: 'manage.team.listing',
                method: 'get'
              });

            case 2:
              return _context20.abrupt("return", _context20.sent);

            case 3:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee20);
    }))();
  }
}; // Expose the API endpoints to Vue and Vuex

Vuex.Store.prototype.$api = apiEndpoints;
export default apiEndpoints;